/**
 * Clerk renders its own markup, so it does not inherit the app's Tailwind
 * classes. This maps the pieces that would otherwise look foreign -- radius,
 * the primary action colour, the border and muted text -- onto the same CSS
 * variables shadcn uses, so hosted sign-in and the UserButton menu sit in the
 * app's theme rather than Clerk's defaults.
 *
 * Because the values are `var(...)` references rather than literals, the same
 * object serves light and dark: the variables are redefined under `.dark` in
 * styles.css and Clerk re-resolves them. colorSuccess and colorWarning are the
 * reason --success and --warning have to exist as tokens.
 *
 * Passed once on ClerkProvider; every Clerk component inherits it.
 */
export const clerkAppearance = {
  variables: {
    colorPrimary: "var(--primary)",
    colorText: "var(--foreground)",
    colorTextSecondary: "var(--muted-foreground)",
    colorBackground: "var(--background)",
    colorInputBackground: "var(--background)",
    colorInputText: "var(--foreground)",
    colorDanger: "var(--destructive)",
    colorSuccess: "var(--success)",
    colorWarning: "var(--warning)",
    borderRadius: "var(--radius)",
    fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
    fontSize: "0.875rem",
  },
  elements: {
    card: "shadow-none ring-1 ring-foreground/10",
    formButtonPrimary: "text-sm normal-case",
    footerActionLink: "text-primary",
  },
} as const;
